<template lang="pug">
    v-form.c-form(autocomplete="off" @submit.prevent="submit")

        //  Name field
        v-text-field(
            :error-messages="errors.collect('fullName')"
            :data-vv-as="$t('fields.fullName')"
            :label="$t('fields.fullName')"
            name="fullName"
            v-model="model.fullName"
            v-validate="'required|min:2|max:72'"
            outline
            append-icon="lock"
            disabled
        )

        // Email field
        v-text-field(
            name="email"
            :label="$t('fields.email')"
            type="email"
            v-model="model.email"
            v-validate="{ required: true, email: true }"
            :data-vv-as="$t('fields.email')"
            :error-messages="errors.collect('email')"
            browser-autocomplete="new-password"
            outline
            append-icon="lock"
            disabled
        )

        // Password field
        v-text-field(
            name="password"
            :label="$t('fields.password')"
            v-model="model.password"
            v-validate="{ required: true, min: 6, max: 24, verify_password: true }"
            :data-vv-as="$t('fields.password')"
            :error-messages="errors.collect('password')"
            browser-autocomplete="new-password"
            outline
            ref="password"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibility = !visibility)"
            :type="visibility ? 'text' : 'password'"
        )

        // Password Confirm field
        v-text-field(
            name="passwordConfirmation"
            v-model="model.passwordConfirmation"
            :label="$t('fields.confirm_password')"
            v-model.lazy="model.passwordConfirmation"
            v-validate="{ required: true, min: 6, max:24, is: model.password, verify_password: true }"
            :data-vv-as="$t('fields.confirm_password')"
            :error-messages="errors.collect('passwordConfirmation')"
            outline
            data-vv-as="Confirm Password"
            :append-icon="visibility ? 'visibility' : 'visibility_off'"
            @click:append="() => (visibility = !visibility)"
            :type="visibility ? 'text' : 'password'"
        )

        div.text-center
            div

                // Submit button
                button-component.mx-0.mb-3.submit(
                    large
                    type="submit"
                    color="primary"
                    size="medium"
                    :action="submit"
                    :isLoading="isLoading"
                ) {{ $t('auth.registrationGymPass.button') }}

            div.hint
                span {{ $t('auth.registrationGymPass.bottomText') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import { mapActions, mapGetters } from 'vuex';
    import auth from '~api/auth';

    export default {
        $_veeValidate: {
            validator: 'new'
        },
        components: {
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        data() {
            return {
                model: {
                    fullName: '',
                    email: '',
                    password: '',
                    passwordConfirmation: ''
                },
                email: null,
                firstName: null,
                lastName: null,
                visibility: false,
                loading: false
            };
        },
        computed: {
            ...mapGetters('auth', ['isLoading'])
        },
        async beforeMount() {
            this.email =
                this.$route.query && this.$route.query.em
                    ? this.$route.query.em
                    : null;
            this.firstName =
                this.$route.query && this.$route.query.first
                    ? this.$route.query.first
                    : null;
            this.lastName =
                this.$route.query && this.$route.query.last
                    ? this.$route.query.last
                    : null;

            const resp = await auth.getGymPassMember({
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName
            });

            if (resp.ok) {
                const { firstName, lastName, email } = resp.data;
                this.model.fullName = `${firstName} ${lastName}`;
                this.model.email = email;
            }
        },
        mounted() {
            const dict = {
                custom: {
                    fullName: {
                        required: 'Full Name field is required',
                        min: 'Your Full Name must be at least 2 characters.',
                        max: 'Your Full Name may not be greater than 72 characters'
                    },
                    email: {
                        email: 'Invalid Email',
                        required: 'Email field is required'
                    },
                    password: {
                        required: 'Password field is required',
                        min: 'Your Password must be at least 8 characters.',
                        max: 'Your Password may not be greater than 24 characters'
                    },
                    passwordConfirmation: {
                        required: 'Confirm Password field is required',
                        is: 'Oops! It looks like your Password doesn’t match.',
                        min: 'Your Password must be at least 8 characters.',
                        max:
                            'Your Password may not be greater than 24 characters'
                    }
                }
            };

            this.$validator.localize('en', dict);
        },
        methods: {
            ...mapActions('auth', ['registrationGymPass']),

            /**
             * Create user and redirect to confirmation registration page
             */
            async submit() {
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                this.registrationGymPass({
                    model: this.model,
                    token: this.email
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .hint
        font-size: 12px
</style>
